/* eslint-disable */
import React, { useEffect, useState } from "react";
import { alphabeticalOnlyRegex } from "constants/regex";
import { capitalize } from "utils/formatters";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  Avatar,
  Chip,
  FormControl,
  OutlinedInput,
  TextField,
} from "@mui/material";
import { Grid, Button, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useValidEmail } from "../../hooks/useValidEmail";
import { btnStyle, inputStyle, tagIconstyle, tagStyle } from "./styles";
import { PAGES } from "constants/pages";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  selectClinicianUpdateAvatarLoading,
  selectCurrentClinician,
  selectCurrentClinicianLoading,
} from "store/ClinicianStore/selectors";
import {
  updateClinician,
  updateCurrentClinicianAvatar,
} from "store/ClinicianStore/actions";
import CloseIcon from "@mui/icons-material/Close";
import { MultiSelect } from "components/SportSelect/MultiSelect";
import { sportsNames } from "pages/PatientOverview/components/Common/common";
import { USER_GROUPS } from "constants/roles";
import { useValidName } from "hooks/useValidName";
import { enqueueSnackbar } from "notistack";
import TeamSelector from "./TeamSelector";

const ConfigUser: React.FC<any> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const [uploadAvatarError, setUploadAvatarError] = useState("");
  const {
    name: firstName,
    setName: setFirstName,
    nameIsValid,
  } = useValidName(null);
  const {
    name: lastName,
    setName: setLastName,
    nameIsValid: lastNameIsValid,
  } = useValidName(null);
  const { email, setEmail, emailIsValid } = useValidEmail("");
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const [phone, setPhone] = useState("");

  const currentClinician = useAppSelector(selectCurrentClinician);
  const currentClinicianLoading = useAppSelector(selectCurrentClinicianLoading);
  const updateAvatarLoading = useAppSelector(
    selectClinicianUpdateAvatarLoading
  );

  const names = sportsNames;

  const [tags, setTags] = React.useState<string[]>([]);

  const addToTags = (value: string) => {
    setTags([...tags, value]);
  };

  const removeFromTags = (value: string) => {
    setTags(tags.filter((item) => item !== value));
  };

  const onItemSelected = (e: any, name: string) => {
    if (e.target.checked) {
      addToTags(name);
    } else {
      removeFromTags(name);
    }
  };

  useEffect(() => {
    setFirstName(currentClinician?.profileInfo.firstName || "");
    setLastName(currentClinician?.profileInfo.lastName || "");
    setEmail(currentClinician?.profileInfo.email || "");
    setPhone(currentClinician?.profileInfo.phoneNumber || "");
    setTags(currentClinician?.profileInfo.sports || []);
  }, [currentClinician?.profileInfo]);

  const hiddenFileInput = React.useRef<any>(null);

  const handleClick = () => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  const handleChange = async (event: any) => {
    setUploadAvatarError("");
    const fileUploaded = event.target.files[0];
    const allowedImgTypes = ["image/png", "image/jpeg"];
    const allowedFileExtensions = ["png", "jpeg", "jpg"];

    if (!allowedImgTypes.includes(fileUploaded.type)) {
      setUploadAvatarError(
        "Please select one of the allowed formats: " +
          allowedFileExtensions.join(", ")
      );
    }
    let formData = new FormData();
    formData.append("file", fileUploaded);
    formData.append("contentType", fileUploaded.type);
    formData.append("fileExtension", fileUploaded.type.split("/")[1]);

    dispatch(
      updateCurrentClinicianAvatar(
        formData,
        () => {},
        () => {
          setUploadAvatarError("Error while uploading image");
        }
      )
    );

    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = null;
    }
  };

  const handleSubmitPress = async () => {
    if (
      !currentClinician?._id ||
      genericErrorMessage != "" ||
      nameIsValid != "" ||
      lastNameIsValid != ""
    )
      return;

    dispatch(
      updateClinician(currentClinician?._id, {
        firstName: firstName ?? undefined,
        lastName: lastName ?? undefined,
        phoneNumber: phone,
        sports: tags ?? [],
      })
    );
  };

  return (
    <Grid
      container
      alignItems="flex-start"
      justifyContent="center"
      alignContent="flex-start"
      spacing={5}
    >
      <Grid item xs={4} md={3} xl={2} container justifyContent="center">
        <Avatar
          alt="Remy Sharp"
          src={currentClinician?.imageUrl}
          sx={{ width: 200, height: 200 }}
        />
        <Button
          type="submit"
          color="primary"
          variant="contained"
          style={{
            ...btnStyle,
            width: "158px",
            marginTop: "20px",
            textTransform: "none",
            marginBottom: "50px",
          }}
          onClick={handleClick}
        >
          {updateAvatarLoading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            "Update Image"
          )}
        </Button>
        <p className="text-red-600 text-xs">{uploadAvatarError}</p>
        <input
          type="file"
          ref={hiddenFileInput}
          onChange={handleChange}
          style={{ display: "none" }}
        />
      </Grid>
      <Grid item md={9} xl={9}>
        {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
          <Grid container justifyContent="flex-end" item md={12} xl={12}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={{
                ...btnStyle,
                width: "158px",
                top: "0",
                textTransform: "none",
              }}
              onClick={(e) => {
                history.push("/invite-athlete");
              }}
            >
              Manage Invites
            </Button>
          </Grid>
        )}
        <Grid
          container
          justifyContent="flex-end"
          spacing={10}
          style={{ marginTop: "40px" }}
        >
          <Grid item md={6} xl={6} container justifyContent="flex-end">
            <TextField
              label="First name"
              error={nameIsValid != ""}
              size="small"
              variant="filled"
              fullWidth
              type="text"
              value={firstName}
              onChange={(e: any) => {
                if (alphabeticalOnlyRegex.test(e.target.value)) {
                  setFirstName(capitalize(e.target.value));
                }
              }}
              placeholder="First Name"
            />
          </Grid>
          <Grid item md={6} xl={6} container justifyContent="center">
            <TextField
              label="Last name"
              error={lastNameIsValid != ""}
              size="small"
              fullWidth
              variant="filled"
              style={{ marginTop: "0" }}
              type="text"
              value={lastName}
              onChange={(e: any) => {
                if (alphabeticalOnlyRegex.test(e.target.value)) {
                  setLastName(capitalize(e.target.value));
                }
              }}
              placeholder="Last Name"
            />
          </Grid>
        </Grid>
        <Grid container spacing={10} justifyContent="flex-end">
          <Grid item md={6} xl={6} container justifyContent="flex-end">
            <TextField
              error={genericErrorMessage != ""}
              size="small"
              variant="filled"
              fullWidth
              type="text"
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
              placeholder="Email"
              disabled
            />
          </Grid>
          <Grid item md={6} xl={6} container justifyContent="center">
            <FormControl fullWidth>
              <PhoneInput
                country={"us"}
                inputStyle={{
                  width: "100%",
                  height: "48px",
                  background: "#ededed",
                }}
                placeholder="Phone number"
                value={phone}
                onChange={(phone) => setPhone(phone)}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={10}
          justifyContent="flex-end"
          alignItems="baseline"
        >
          {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
            <Grid xs={12} style={{ display: "flex", marginTop: "10px" }}>
              <Grid item md={6} xl={6} container justifyContent="flex-end">
                <FormControl sx={{ ml: 5, mr: 5 }} fullWidth variant="outlined">
                  <MultiSelect
                    options={names}
                    selectedOptions={tags}
                    onItemSelected={onItemSelected}
                    paddingTop={0}
                    hint={"Select sports your athletes are in"}
                    menuSubTitle={"(M = Men's, W = Women's)"}
                    style={{ ...inputStyle, marginBottom: 1 }}
                    height={48}
                    emptyMessage="Please select your sport in Coach Tools -> Sport preferences"
                  />
                  {
                    <Grid
                      style={{ flexBasis: "auto" }}
                      md={12}
                      xl={12}
                      container
                    >
                      {tags &&
                        tags.map((tag) => (
                          <Grid style={{ flexBasis: "auto" }} item>
                            <Chip
                              key={tag}
                              style={{ ...tagStyle }}
                              deleteIcon={
                                <CloseIcon style={{ ...tagIconstyle }} />
                              }
                              label={tag}
                              variant="outlined"
                              onDelete={() => removeFromTags(tag)}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  }
                </FormControl>
              </Grid>

              <Grid item md={6} xl={6} container justifyContent="center">
                <TeamSelector />
              </Grid>
            </Grid>
          )}
          <Grid item md={6} xl={6} container justifyContent="flex-end">
            <Button
              type="submit"
              color="primary"
              disabled={
                !currentClinician?._id ||
                genericErrorMessage != "" ||
                nameIsValid != "" ||
                lastNameIsValid != ""
              }
              variant="contained"
              onClick={handleSubmitPress}
              style={{
                width: "132px",
                backgroundColor: "#51A8F0",
                fontSize: "14px",
                lineHeight: "30px",
                fontFamily: "SofiaPro",
                fontWeight: "700",
                textTransform: "none",
                height: "42px",
              }}
            >
              {currentClinicianLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                "Save Changes"
              )}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <p style={{ textAlign: "start", color: "grey" }}>App version: 2.5.6</p>
    </Grid>
  );
};

export default ConfigUser;
